import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getToken, getUser, isInstituteSession, clearSession, hasAnyInstituteCapability, hasInstituteCapability } from '../../lib/instituteAuth';
import { MENU_SECTIONS } from '../layout/InstituteLayout';

const LoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-slate-950">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-teal-800 dark:border-teal-400" />
  </div>
);

function pathAccess(pathname) {
  const items = MENU_SECTIONS.flatMap((s) => s.items);
  const exact = items.find((i) => i.to === pathname);
  if (exact) return exact;
  return items.find((i) => pathname.startsWith(`${i.to}/`)) || null;
}

function pathAllowed(pathname) {
  const item = pathAccess(pathname);
  if (!item) return true;
  if (Array.isArray(item.capabilitiesAny) && item.capabilitiesAny.length) {
    return hasAnyInstituteCapability(...item.capabilitiesAny);
  }
  if (item.capability) return hasInstituteCapability(item.capability);
  return true;
}

/**
 * Protege rutas /instituto/* autenticadas.
 * Requiere institute_token, portal institute y capability del módulo (si aplica).
 */
export default function InstituteRouteGuard({ children }) {
  const location = useLocation();
  const [ready, setReady] = useState(false);
  const [allowed, setAllowed] = useState(false);
  const [forbidden, setForbidden] = useState(false);

  useEffect(() => {
    const token = getToken();
    const user = getUser();
    if (!token || !user) {
      clearSession();
      setAllowed(false);
      setForbidden(false);
      setReady(true);
      return;
    }
    if (!isInstituteSession()) {
      setAllowed(false);
      setForbidden(false);
      setReady(true);
      return;
    }
    if (!pathAllowed(location.pathname)) {
      setAllowed(false);
      setForbidden(true);
      setReady(true);
      return;
    }
    setForbidden(false);
    setAllowed(true);
    setReady(true);
  }, [location.pathname]);

  if (!ready) return <LoadingScreen />;
  if (forbidden) {
    return <Navigate to="/instituto/escritorio" replace />;
  }
  if (!allowed) {
    return <Navigate to="/instituto/login" replace state={{ from: location.pathname }} />;
  }
  return children;
}
